import { z } from 'zod'
import { DeviceHexacodeSchema } from './Device'

// all permissions related types and schemas
export const LinkedAccessGroupSchema = z.object({
  group: z.string(),
  readOnly: z.boolean(),
})
export const LinkedAccountSchema = z.object({
  id: z.string(),
  readOnly: z.boolean(),
})
export const LinkedDeviceSchema = z.object({
  hexacode: DeviceHexacodeSchema,
  readOnly: z.boolean(),
})
export const AccessGroupLinkedAccountsSchema = z.object({
  name: z.string(),
  linkedAccounts: LinkedAccountSchema.array(),
})
export const AccessGroupLinkedDevicesSchema = z.object({
  name: z.string(),
  linkedDevices: LinkedDeviceSchema.array(),
})
export const AccessGroupCreateRequestSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  accounts: LinkedAccountSchema.array(),
  devices: LinkedDeviceSchema.array(),
})
export const AccessGroupUpdateRequestSchema = AccessGroupCreateRequestSchema.extend({
  id: z.string(),
})
export type AccessGroupCreateRequest = z.infer<typeof AccessGroupCreateRequestSchema>
export type AccessGroupUpdateRequest = z.infer<typeof AccessGroupUpdateRequestSchema>
export type AccessGroupRequest = AccessGroupCreateRequest | AccessGroupUpdateRequest

export const AccountPermissionsUpdateRequestSchema = z.object({
  account: z.string().nullable(),
  devices: LinkedDeviceSchema.array(),
  accessGroups: LinkedAccessGroupSchema.array(),
})
export const DevicePermissionsUpdateRequestSchema = z.object({
  hexacode: DeviceHexacodeSchema,
  accounts: LinkedAccountSchema.array(),
  accessGroups: LinkedAccessGroupSchema.array(),
})
export const DevicePermissionsDetailsSchema = z.object({
  hexacode: DeviceHexacodeSchema,
  templateName: z.string(),
  accounts: z.array(LinkedAccountSchema),
  accessGroups: z.array(LinkedAccessGroupSchema),
  accessGroupsFromTemplates: z.array(LinkedAccessGroupSchema),
})
export const LinkedDeviceFromGroupViaTemplateSchema = z.object({
  hexacode: DeviceHexacodeSchema,
  template: z.string(),
  group: z.string(),
  readOnly: z.boolean(),
})
export const AccountPermissionsDetailsSchema = z.object({
  id: z.string(),
  devices: z.array(LinkedDeviceSchema),
  accessGroups: z.array(LinkedAccessGroupSchema),
  devicesFromGroups: z.record(z.string(), z.array(LinkedDeviceSchema)),
  devicesFromGroupTemplates: z.array(LinkedDeviceFromGroupViaTemplateSchema),
})

export type AccountPermissionsUpdateRequest = z.infer<typeof AccountPermissionsUpdateRequestSchema>
export type DevicePermissionsUpdateRequest = z.infer<typeof DevicePermissionsUpdateRequestSchema>
export type DevicePermissionsDetails = z.infer<typeof DevicePermissionsDetailsSchema>
export type AccountPermissionsDetails = z.infer<typeof AccountPermissionsDetailsSchema>
export type LinkedAccount = z.infer<typeof LinkedAccountSchema>
export type LinkedDevice = z.infer<typeof LinkedDeviceSchema>
export type LinkedDeviceFromGroupViaTemplate = z.infer<typeof LinkedDeviceFromGroupViaTemplateSchema>
export type AccessGroupLinkedAccounts = z.infer<typeof AccessGroupLinkedAccountsSchema>
export type AccessGroupLinkedDevices = z.infer<typeof AccessGroupLinkedDevicesSchema>

export type AccessGroupDetails = { // backend data model no validation needed
  id: string | null
  name: string
  accounts: LinkedAccount[]
  devices: LinkedDevice[]
  devicesFromTemplates: LinkedDevice[]
}
